module.exports = __webpack_public_path__ + "assets-cabinet/img/notification.607b360c.svg";